export const NUMBER_REGEXP_MAP = {
	STRIP_LEADING_ZEROS: /^0+(?=\d)/,
	NON_DIGITS: /\D/g,
	NON_DIGITS_DOT: /[^\d.]/g,
	COMMA: /,/g
} as const
